/**
 * 全局API地址
 */
// const path = 'energy';
// const path = 'energy-xw';
// const path = 'energy-lxx';
// const path = 'energy-lzy';

// let path = paths.path();
let path = '/energy-carbon'; //测试环境（能耗管控）
// let path = '/energy-carbon-bjiang2';  //江兵

let fileServiceUrl = process.env.VUE_APP_FILE_URL;
const API = {
  getUserInfo: '/mlyun-uc/login/authInfoByToken',
  mlyun_auth_server_auth_safelogin: `/mlyun-auth/server/auth/safelogin`,
  file_uploadFile: `${path}/file/uploadFile`,

  wechat_getUserByCode: `${path}/wechat/getUserByCode`,
  wechat_getSign: `${path}/wechat/getSign`,
  password_updatePwdByUserName: `${path}/password/updatePwdByUserName`,
  user_findListByOpenId: `/mlyun-uc/user/findListByOpenId`,
  user_updateOpenIdEnpty: `/mlyun-uc/user/updateOpenIdEnpty`,
  repair_order_getProcessingOrdersCountByHanderId: `${path}/repair/order/getProcessingOrdersCountByHanderId`,
  repair_order_getProcessingOrdersByHanderId: `${path}/repair/order/getProcessingOrdersByHanderId`,
  repair_order_detail_with_device_relations: `${path}/repair/order/detail-with-device-relations`,
  repair_order_audi_records: `${path}/repair/order/audi-records`,
  repair_order_process: `${path}/repair/order/process`,
  sysOrganTreeRelation_treeByManagerOrgan: `${path}/sysOrganTreeRelation/treeByManagerOrgan`,

  tree_space_no_append: `${path}/tree/space_no_append`,
  meter_space_device_list: `${path}/meter/space-device-list`,
  repair_apply_add: `${path}/repair/apply/add`,
  repair_apply_queryList: `${path}/repair/apply/queryList`,
  repair_apply_detail: `${path}/repair/apply/detail`,

  courtyard_listAll: `${path}/courtyard/listAll`,
  floor_list: `${path}/floor/list`,
  storeys_list: `${path}/storeys/list`,
  room_list: `${path}/room/list`,
  repair_order_dropdown_options: `${path}/repair/order/dropdown-options`,
  device_product_tree: `${path}/device/product/tree`,
};

export default API;
